<template>
  <div></div>
</template>

<script>
export default {
  name: "subjectC",
  props: ["childModules"],
  data() {
    return {};
  },
  created() {
  },
  computed: {},
  methods: {
    
  },
  watch: {},
  filters: {},
};
</script>

<style lang="less" >

</style>